import { Container } from '@/components/container';
import { Demo1LightSidebarContent } from '@/pages/dashboards/demo1';
const AuthenticationGetStartedPage = () => {
  return <Container>
      <Demo1LightSidebarContent />
    </Container>;
};
export { AuthenticationGetStartedPage };